import type moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'

type StartOrEnd = 'start' | 'end'
type Period = 'month' | 'week'

interface Data {
  from: string
  to: string
  team_id?: string
  location_id?: string
}

function momentMethod(date: moment.Moment, startOrEnd: StartOrEnd, period: Period): moment.Moment {
  if (startOrEnd === 'start') {
    return date.clone().startOf(period)
  } else {
    return date.clone().endOf(period)
  }
}

function formatDate(
  date: moment.Moment,
  startOrEnd: StartOrEnd,
  includeWholeWeeks: boolean
): string {
  let newDate = momentMethod(date, startOrEnd, 'month')

  if (includeWholeWeeks) {
    newDate = momentMethod(newDate, startOrEnd, 'week')
  }

  return dateToString(newDate, 'backend')
}

const generateFetchData = (
  date: moment.Moment,
  filterByValue: string,
  includeWholeWeeks: boolean
) => {
  const [type, filterBy] = filterByValue.split('___')
  let data: Data = {
    from: formatDate(date, 'start', includeWholeWeeks),
    to: formatDate(date, 'end', includeWholeWeeks),
  }

  if (filterBy === 'away') {
    return data
  }

  switch (type) {
    case 'team':
      data = { ...data, team_id: filterBy }
      break

    case 'location':
      data = { ...data, location_id: filterBy }
      break

    case 'employees':
      data = { ...data, [`${filterBy}`]: true }
      break

    default: // do nothing
  }

  return data
}

export default generateFetchData
